// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as GeocodeApiMapper$PorterinFeature from "../entity-mappaer/GeocodeApiMapper.mjs";

function fetchLocation(place_id) {
  return Js_promise.$$catch((function (err) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: err
                          });
              }), Js_promise.then_((function (data) {
                    return Promise.resolve({
                                TAG: /* Ok */0,
                                _0: GeocodeApiMapper$PorterinFeature.execute(data)
                              });
                  }), new (window.google.maps.Geocoder)().geocode({
                      placeId: place_id
                    })));
}

function getGeocodeFromPlaceId(place_id, onSuccess, onError) {
  ApiUtils$Catalyst.handleAPIRequest((function (param) {
          return fetchLocation(place_id);
        }), Curry.__1(onSuccess), Curry.__1(onError));
}

function fetchLocationFromLatLng(latLng) {
  return Js_promise.$$catch((function (err) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: err
                          });
              }), Js_promise.then_((function (data) {
                    return Promise.resolve({
                                TAG: /* Ok */0,
                                _0: GeocodeApiMapper$PorterinFeature.execute(data)
                              });
                  }), new (window.google.maps.Geocoder)().geocode({
                      location: latLng
                    })));
}

function getGeocodeFromLatLng(latLng, onSuccess, onError) {
  ApiUtils$Catalyst.handleAPIRequest((function (param) {
          return fetchLocationFromLatLng(latLng);
        }), Curry.__1(onSuccess), Curry.__1(onError));
}

export {
  fetchLocation ,
  getGeocodeFromPlaceId ,
  fetchLocationFromLatLng ,
  getGeocodeFromLatLng ,
}
/* GeocodeApiMapper-PorterinFeature Not a pure module */
